import type { SubmissionsExportMetaKey } from "../../types/submission";
import type {
  ExcelSyncPackagePayload,
  SubmissionSyncSidecar,
} from "../../types/submissionSync";
import { resolveExportStaffColumnParams } from "../forms/submissionsExport";

export function buildExcelSyncSubmissionsQuery(params: {
  afterId?: number;
  count?: number;
  fieldIds?: number[];
  metaKeys?: SubmissionsExportMetaKey[];
  order?: number[];
}): string {
  const query = new URLSearchParams({
    afterId: String(params.afterId ?? 0),
    count: String(params.count ?? 100),
  });
  if (params.fieldIds?.length) {
    query.set("fields", params.fieldIds.join(","));
  }
  if (params.metaKeys?.length) {
    query.set("meta", params.metaKeys.join(","));
  }
  if (params.order?.length) {
    query.set("order", params.order.join(","));
  }
  return `?${query.toString()}`;
}

/** JSON для POST package: staffColumns только массив, иначе поле не шлём. */
export function buildExcelSyncPackagePayload(options: {
  fieldIds?: number[];
  meta?: SubmissionsExportMetaKey[];
  order?: number[];
  includeStaffMarks: boolean;
  staffColumnIds: number[];
  selectedStaffColumnIds: Set<number>;
}): ExcelSyncPackagePayload {
  const payload: ExcelSyncPackagePayload = {};
  if (options.fieldIds?.length) payload.fields = options.fieldIds;
  if (options.meta?.length) payload.meta = options.meta;
  if (options.order?.length) payload.order = options.order;

  if (!options.includeStaffMarks) {
    payload.staffColumns = [];
    return payload;
  }

  payload.includeStaffMarks = true;
  const selected = resolveExportStaffColumnParams(
    options.staffColumnIds,
    options.selectedStaffColumnIds,
  );
  payload.staffColumns = selected ?? [...options.staffColumnIds];
  return payload;
}

export function excelSyncDeltaParamsFromSidecar(
  sidecar: SubmissionSyncSidecar,
  afterId = sidecar.cursor.afterId,
  count = 100,
) {
  return {
    afterId,
    count,
    fieldIds: sidecar.columns.fieldIds,
    metaKeys: sidecar.columns.metaKeys,
    order: sidecar.columns.orderIds ?? undefined,
  };
}
